<!--声音克隆-->
<template>
  <div>
    <div class="clone-box fs18 cr" v-if="myVoiceArray.length <= 0">
      <div class="none-bar">
        <div class="none-top">
          <img :src="`编组18.png` | fullImageUrl"/>
          <p @click="handleAdd">定制专属声音</p>
        </div>
        <img :src="`编组19.png` | fullImageUrl" style="margin-top: 94px"/>
      </div>
    </div>
    <div class="clone-box fs18 cr" v-else>
      <div class="flex ac">
        <p class="clone-box-title">
          声音克隆<span v-if="myVoiceArray.length > 0"
        >·{{ myVoiceArray.length }}</span
        >
        </p>
        <div class="flex ac">
          <div class="select-box fle mr30">
            <div class="flex ac jb">
              <div style="margin-left: 32px">
                <el-input placeholder="名称搜索" v-model="selectObj.name">
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    style="color: #f7d274"
                    @click="select()"
                  ></el-button>
                </el-input>
              </div>
              <!-- <div class="dz-btn-box cr" @click="handleAdd">+定制专属音频</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="no-fenshen-box" v-if="myVoiceArray.length <= 0">
        <img src="../assets/pcImages/5.1_Icon_1@2x.png" alt="no"/>
        <p>上传一段音频, 快速复刻数字声音</p>
        <div class="ks-dingzhi cr" @click="handleAdd">+快速定制</div>
      </div>
      <div class="my-voice" v-if="show1">
        <div class="flex ac fw">
          <div
            class="clone-voice flex jb mr25 cr"
            @click="handleAdd"
            v-if="myVoiceArray.length > 0"
          >
            <img :src="`位图20.png` | fullImageUrl" alt=""/>
            <div class="part1">
              <p>极速克隆您的专属声音</p>
              <p>上传音频自动克隆声音</p>
            </div>
            <div class="part2">
              <div class="part2-text">定制专属声音</div>
              <!-- <div></div> -->
              <!-- <i class="el-icon-right"></i> -->
            </div>
          </div>
          <div
            class="every-voice flex ac"
            v-for="(item, index) in myVoiceArray"
            :key="index"
          >
            <div
              class="card-img"
              @mouseover="handleMouse(item)"
              @mouseleave="handleMouseOut"
              @click="handlePlay(item)"
            >
              <img :src="`编组57.png` | fullImageUrl" alt=""/>
              <div
                class="hover-box icon-player playing"
                v-if="mouseState && hoverId == item.id"
              >
                <div class="play-pause-btn">
                  <i
                    class="el-icon-video-play"
                    v-if="palyState == 1 || clickId != item.id"
                    style="color: #ffffff; font-size: 25px"
                  ></i>
                  <i
                    class="el-icon-video-pause"
                    v-if="palyState == 2"
                    style="color: #ffffff; font-size: 25px"
                  ></i>
                  <img
                    class="playing-box"
                    v-if="palyState == 3 && clickId == item.id"
                    src="../assets/pcImages/voice-playing.gif"
                  />
                </div>
              </div>
            </div>
            <div>
              <p class="pp4">
                {{ item.name }}
              </p>

              <p class="pp5" v-if="item.generate_status == 1">
                {{ item.voice_channel_name ? item.voice_channel_name : getName(item.api) ? getName(item.api) : item.version_name }} 声音克隆中.....
              </p>
              <!--            <p class="pp5" v-else>高保真声音克隆 <span style="color: #89B5FB" v-if="item.train_status==2">(已确认)</span><span style="color: #89B5FB" v-if="item.train_status!=2&&item.remained_times>0">(未确认，可修改{{item.remained_times}}次)</span></p>-->

              <div v-else class="flex ac jb">
                <div
                  class="type1-tips-new"
                  :style="{
                    background:
                      item.api == 'fish'
                        ? '#2550F6'
                        : item.api == 'hs'
                        ? '#8EB053'
                        : item.api == 'xf'
                        ? '#2550F6'
                        : '#C58E34',
                  }"
                >
                  {{ item.voice_channel_name ? item.voice_channel_name : getName(item.api) ? getName(item.api) : item.version_name }}
                </div>
                <p class="pp5" style="padding-bottom: 2px; margin-left: 5px">
                  {{ item.voice_channel_name ? item.voice_channel_name : getName(item.api) ? getName(item.api) : item.version_name }} 声音克隆
                  <span
                    v-if="item.generate_status == 3"
                    class="ml05 mr05"
                    style="color: #f57241; margin-left: 5px"
                  >失败</span
                  >
                  <span style="color: #f7d274"
                  >{{
                      item.remained_times > 0
                        ? `(可编辑${item.remained_times}次)`
                        : "不可编辑"
                    }}
                  </span>
                </p>
              </div>
            </div>
            <div class="handle-box">
              <el-popover
                placement="bottom-start"
                width="1"
                v-model="item.visible"
              >
                <div class="handle-box-pop">
                  <div
                    class="text-btn"
                    style="margin-bottom: 12px; margin-top: 5px"
                    @click="handleReName(item)"
                  >
                    重命名
                  </div>
                  <div
                    v-if="item.generate_status != 1 && item.remained_times > 0"
                    style="margin-bottom: 5px"
                    class="text-btn"
                    @click="handleEdit(item)"
                  >
                    修改
                  </div>
                  <div
                    class="text-btn"
                    v-if="item.remained_times == 0"
                    @click="handleDelete(item)"
                  >
                    删除
                  </div>
                </div>
                <template slot="reference">
                  <div class="edit-btn">
                    编辑
                    <!-- <i class="el-icon-more"></i> -->
                  </div>
                </template>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <audio
        style="
          width: 1px;
          height: 1px;
          opacity: 0;
          position: fixed;
          right: 0;
          bottom: 0;
        "
        ref="audioPlayer"
        @ended="audioEnded"
        :src="audioSrc"
        controls
      ></audio>
    </div>

    <el-dialog
      title="录制≥10秒，即刻克隆"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="30%"
    >
      <div class="dialog-box">
        <h3>使用和付费提示</h3>
        <ul>
          <li>录制时的语气和情感也会被克隆，请按期望的音色效果进行朗读。</li>
          <li>
            我们建议您使用≥10秒的清晰语音音频，且不应包含任何混响、回声及背景噪音，以取得最佳效果。
          </li>
          <li>
            对于音频文件的质量，一般手机录音机是mp3格式都可以满足,文件大小不超过10M。
          </li>
          <li>
            离麦3-5厘米，1人人声，样本质量比长度更重要。有噪音的样本可能会产生不好
            的结果，请尽可能提供高质量的样本语音。
          </li>
        </ul>
        <div class="clone-section">
          <h3>使用规范</h3>
          <div class="guifan">
            您承诺所录制的音频为您本人所有或已获得合法授权， 并遵守<span
            style="color: #f7d274"
          >
              《本平台音色克隆功能使用规范》 </span
          >。 为实现本功能，您需要朗读文案并录制音频。
          </div>
        </div>

        <div class="flex ac mt20">
          <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
          <span
            style="
              text-decoration: underline;
              cursor: pointer;
              font-weight: 400;
              font-size: 12px;
              color: rgba(255, 255, 255, 0.7);
              line-height: 18px;
            "
            @click="goProtocol"
          >《本平台音色克隆使用规范》</span
          >
        </div>
      </div>

      <span slot="footer" class="tc cr">
        <div class="submit-btn" @click="handleSumbit">我已知晓，同意</div>
      </span>
    </el-dialog>

    <el-dialog
      title="声音克隆"
      :visible.sync="dialogVisible2"
      width="50%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="shengyinkelong"
    >
      <div class="shengyinkelong" style="margin-top: -10px">
        <p class="pp3"><span style="color: red">*</span> 声音名称</p>
        <el-input
          :disabled="nameDisabled"
          placeholder="请输入声音名称"
          v-model="voiceUpName"
        >
        </el-input>
        <div class="pp3 flex ac">
          <div><span style="color: red">*</span> 音频要求</div>
          <div class="flex ac" style="margin-left: 8px" @click="handleReUplod">
            <img
              :src="`编组13.png` | fullImageUrl"
              style="height: 12px; width: 12px"
            />
            <div class="pp3" style="color: #f7d274; padding-left: 5px">
              重置
            </div>
          </div>
        </div>

        <div class="voice-yq" style="margin-top: -10px">
          <ul class="ul-box">
            <li>文件格式：mp3、m4a、wav</li>
            <li>音频时长：{{ upTip }}</li>
            <li>音频大小：小于20MB</li>
          </ul>
        </div>
        <p style="color: #f7d274; margin: 15px 0 0 0" v-if="remained_times > 0">
          剩余修改次数:{{ remained_times }}
        </p>
        <div class="upload-box mt20" v-if="fileList.length <= 0">
          <el-upload
            ref="upload"
            drag
            :action="uploadUrl"
            accept=".mp3,.wav,.m4a,.MP3,.WAV,.M4A"
            :on-progress="handleUping"
            :on-success="handleFileUpSuccess"
            :on-error="handleFileUpError"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            multiple
            :limit="1"
            :headers="myHeaders"
            :data="needParam"
          >
            <div>
              <!-- <i class="el-icon-upload"></i> -->
              <img :src="`编组58.png` | fullImageUrl"/>
              <div class="video-one">点击上传音频</div>
              <div class="el-upload__text">请上传一段音频，用于声音克隆</div>
              <div class="el-upload__text">
                将文件拖到此处，或<em style="color: #f7d274">点击上传</em>
              </div>
            </div>
          </el-upload>
        </div>
        <div class="upload-box mt20 flex ac jc" v-else>
          <audio ref="audioPlayer" :src="fileList[0].url" controls></audio>
          <el-button
            type="warning"
            size="mini"
            style="margin-left: 20px"
            @click="handleReUplod"
          >重新上传
          </el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleStartClone2"
        >开始克隆</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="重命名"
      :visible.sync="dialogVisible3"
      width="25%"
      top="35vh"
    >
      <el-input v-model="name" placeholder="请输入名字"/>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sumbitName2">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog
      title="选择音频训练方式"
      :visible.sync="dialogVisible4"
      :width="
        voiceChannelList.length >= 4
          ? '65%'
          : voiceChannelList.length == 3
          ? '52%'
          : voiceChannelList.length == 2
          ? '35%'
          : '20%'
      "
    >
      <div class="ai-choose-box flex">
        <div
          class="ai-part2-box"
          v-for="(item, index) in voiceChannelList"
          :key="index"
          @click="goCreate(item.api)"
          v-if="item.api != 'xf'"
        >
          <div class="aipp4 flex ac jc">
            <div :style="{ color: getDigitColor(index) }">
              {{ item.credits > 0 ? item.credits + "算力" : "免费" }}
              <!-- <span class="jf-text" v-if="item.credits > 0">积分</span> -->
              <span class="jf-text" v-if="item.free_times > 0"
              >(剩余{{ item.free_times }}次)</span
              >
            </div>
          </div>
          <div class="aipp1 bold flex ac jc te">
            <span class="te">{{ item.name }}</span>
          </div>
          <div class="aipp2 te mb15">{{ item.desc }}</div>
          <div class="aipp21" v-if="item.train_times > 0">
            不要重复点击，已创建好的音频请去【声音克隆】里面修改
          </div>
          <div class="aibtn2" :style="{ background: getDigitColor(index) }">
            开始生成
          </div>
          <div class="aipp5" v-if="item.train_times > 0" :style="{ background: getDigitColor(index) }">
            <!-- :style="{ color: getDigitColor(index) }" -->
            <div v-if="item.api=='mm'">可修改{{ item.train_times }}次</div>
            <div v-else>可修改{{ item.train_times }}次</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    postVoice,
    getVoice,
    delVoice,
    voiceConfirm,
    uploadSign,
    uploadComplete,
    gvoiceChannel,
  } from "../api/user";
  import {throttle} from "../../utils";

  export default {
    name: "",
    computed: {
      myHeaders() {
        return {"x-token": window.localStorage.getItem("xcToken") || ""};
      },
      theme() {
        return this.$store.getters.getTheme;
      },
    },
    data() {
      return {
        choosed: 1,
        name: "",
        dialogVisible1: false,
        checked: true,
        dialogVisible2: false,
        dialogVisible3: false,
        dialogVisible4: false,
        dialogVisible5: false,
        mouseState: false,
        palyState: 1,
        show1: true,
        show2: true,
        fileList: [],
        voiceUpName: "",
        loading: "",
        file_id: "",
        myVoiceArray: [],
        generate: 0,
        voiceArray: [],
        hoverId: "",
        clickId: false,
        audioSrc: "",
        myOneVoice: {},
        editId: "",
        remained_times: 0,
        selectObj: {
          source: "1",
          page: 1,
          limit: 9999,
          name: "",
        },
        needParam: {},
        uploadUrl: "",
        uploadDir: "",
        uploadSize: "",
        duration: 0,
        clone_usage: "",
        api: "",
        pollingInterval: null,
        nameDisabled: false,
        voiceChannelList: [],
        upTip: "",
        voice_channel_name: ''
      };
    },
    created() {
      if (window.localStorage.getItem("siteJson")) {
        const siteJson = JSON.parse(window.localStorage.getItem("siteJson"));
        this.clone_usage = siteJson.cloneUsage;
      }
      this.choosed = this.$route.query.id || 1;
      this.getVoiceList();
      this.getMyVoiceList();
      this.getUploadSign();
      this.getgvoiceChannel();
    },
    beforeDestroy() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
      }
    },
    mounted() {
      // this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
      // setTimeout(() => {
      //   if (this.generate > 0) {
      //     this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
      //   }
      // }, 1500)
      // this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
    },
    watch: {
      generate: {
        handler(newVal) {
          if (newVal > 0) {
            this.pollingInterval = setInterval(this.getMyVoiceList, 10000);
          }
        },
        immediate: true, // 初始化时立即执行
      },
    },
    methods: {
      handleReUplod() {
        this.fileList = [];
        // 重置上传组件
        this.$refs.upload && this.$refs.upload.clearFiles();
        this.videoUpName = "";
      },
      handleChoosed(val) {
        if (val == 2) {
          this.show1 = false;
        } else if (val == 1) {
          this.show1 = true;
          this.show2 = true;
        }
        this.choosed = val;
      },
      getVoiceList() {
        getVoice({source: "2", page: 1, limit: 9999}).then((res) => {
          this.voiceArray = res.data.list;
        });
      },
      select() {
        this.getMyVoiceList();
      },
      getMyVoiceList() {
        getVoice({...this.selectObj}).then((res) => {
          this.myVoiceArray = res.data.list;
          this.generate = res.data.generate;
          if (res.data.generate <= 0) {
            if (this.pollingInterval) {
              clearInterval(this.pollingInterval);
            }
          }
        });
      },
      getUploadSign() {
        uploadSign({file_type: "voice"}).then((res) => {
          this.uploadUrl = res.data.host;
          this.uploadDir = res.data.dir;
          this.needParam = {
            OSSAccessKeyId: res.data.access_key_id,
            policy: res.data.policy,
            signature: res.data.signature,
          };
        });
      },
      handleReName(item) {
        this.dialogVisible3 = true;
        this.myOneVoice = item;
      },
      handleAdd() {
        // this.dialogVisible1 = true
        // this.editId = ''
        // this.voiceUpName = ''
        this.remained_times = "";
        this.editId = "";
        this.api = "";
        this.dialogVisible4 = true;
        this.nameDisabled = false;
        this.voiceUpName = "";
      },
      handleEdit(item) {
        if (item.api == "xf") {
          this.$message.error("该渠道的声音，仅支持手持设备的录音修改！");
          return false;
        }

        this.api = item.api;
        this.fileList = [];
        this.editId = item.id;
        this.voiceUpName = item.name;
        this.remained_times = item.remained_times;
        if (item.type == 11) {
          this.nameDisabled = true;
        } else {
          this.nameDisabled = false;
        }
        this.dialogVisible2 = true;
      },
      handleSure(item) {
        this.$confirm(
          "此操作将确认生成该条声音，并且不可修改, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            voiceConfirm({voice_id: item.id}).then(() => {
              this.$message.success("确认成功");
              this.getMyVoiceList();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消确认",
            });
          });
      },
      goCreate(val) {
        this.dialogVisible4 = false;
        this.api = val;
        this.dialogVisible1 = true;
        this.getOneTip(val);
      },

      handleDelete(item) {
        this.$confirm("此操作将永久删除该声音, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            delVoice({id: item.id}).then((res) => {
              if (res) {
                this.$message.success("删除成功");
              }
              this.getMyVoiceList();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },

      sumbitName2: throttle(function () {
        this.sumbitName();
      }, 1000),

      sumbitName() {
        if (this.myOneVoice.id) {
          if (!this.name) {
            this.$message.error("请填写名称后保存");
          } else {
            postVoice({id: this.myOneVoice.id, name: this.name})
              .then((res) => {
                this.$message.success("名称修改成功！");
                this.dialogVisible3 = false;
                this.name = "";
                this.myOneVoice = {};
                this.getMyVoiceList();
              })
              .catch((error) => {
                this.$message.error(error.msg);
              });
          }
        }
      },

      goProtocol() {
        const routeData = this.$router.resolve({
          path: "/protocol",
          query: {
            type: "clone",
          },
        });
        window.open(routeData.href, "_blank");
      },

      handleSumbit() {
        if (this.checked) {
          this.dialogVisible1 = false;
          this.dialogVisible2 = true;
        } else {
          this.$message.error("请阅读并同意《本平台音色克隆使用规范》");
        }
      },

      handleStartClone2: throttle(function () {
        this.handleStartClone();
      }, 1000),

      handleStartClone() {
        if (!this.voiceUpName) {
          this.$message.error("请给您创建的声音起一个名称");
          return false;
        } else if (!this.file_id) {
          this.$message.error("请上传音频");
          return false;
        } else {
          if (this.editId) {
            postVoice({
              name: this.voiceUpName,
              file_id: this.fileList[0].file_id,
              id: this.editId,
              api: this.api,
            })
              .then(() => {
                this.fileList = [];
                // 重置上传组件
                // this.$refs.upload.clearFiles();
                this.voiceUpName = "";
                this.$message.success("上传成功");
                this.getMyVoiceList();
                this.loading.close();
              })
              .catch((error) => {
                this.loading.close();
                this.$message.error(error.msg);
              });
          } else {
            postVoice({
              name: this.voiceUpName,
              file_id: this.fileList[0].file_id,
              api: this.api,
              voice_channel_name: this.voice_channel_name
            })
              .then(() => {
                this.fileList = [];
                // 重置上传组件
                // this.$refs.upload.clearFiles();
                this.voiceUpName = "";
                this.$message.success("上传成功");
                this.getMyVoiceList();
                this.loading.close();
              })
              .catch((error) => {
                this.loading.close();
                this.$message.error(error.msg);
              });
          }
          this.$store.dispatch("updatePoints");
          this.editId = "";
          this.dialogVisible2 = false;
        }
      },
      handleMouse(item) {
        this.mouseState = true;
        this.hoverId = item.id;
      },
      handleMouseOut() {
        if (this.palyState != 3) {
          this.mouseState = false;
        }
      },
      handlePlay(item) {
        this.mouseState = true;
        this.clickId = item.id;
        if (this.palyState == 1) {
          this.palyState = 3;
          this.audioSrc = item.url;
          this.$nextTick(() => {
            const audio = this.$refs.audioPlayer;
            audio.load();
            audio.play();
          });
        } else if (this.palyState == 3) {
          this.palyState = 1;
          this.$refs.audioPlayer.pause();
        }

        // if (this.hoverId != item.id) {
        //   this.hoverId = item.id
        //   this.audioSrc = item.url
        //   this.$nextTick(() => {
        //     const audio = this.$refs.audioPlayer
        //     audio.load()
        //     audio.play()
        //   })
        // } else {
        //   this.hoverId = null
        //   this.$refs.audioPlayer.pause()
        // }
      },
      audioEnded() {
        this.palyState = 1;
      },

      handleReUplod() {
        this.fileList = [];
        // 重置上传组件
        this.$refs.upload && this.$refs.upload.clearFiles();
        this.voiceUpName = "";
      },
      beforeAvatarUpload(file) {
        const that = this;
        var file_type = file.name.split(".").slice(-1);
        var file_name =
          that.uploadDir +
          Date.parse(new Date()) +
          "" +
          parseInt(Math.random() * 100) +
          "." +
          file_type;
        that.needParam.key = file_name;
        that.uploadSize = file.size;

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const url = URL.createObjectURL(file);
        const audio = new Audio(url);
        let result;
        audio.muted = true;
        audio.play().then(() => audio.pause());
        // return new Promise((resolve, reject) => {
        //   audio.addEventListener('loadedmetadata', function () {
        //     result = audio.duration // 获取音频时长
        //     if (result > 180 || result < 5) { // 假设我们限制音频时长不超过180秒
        //       that.$message.error('音频时长应在5秒~180秒之间')
        //       reject()
        //     } else {
        //       resolve()
        //     }
        //   })
        // })
        if (
          fileExtension == "mp3" ||
          fileExtension == "m4a" ||
          fileExtension == "wav"
        ) {
          return true;
        } else {
          that.$message.error("请上传MP3/M4A/WAV格式的音频");
          return false;
        }
      },
      handleRemove() {
        this.fileList = [];
      },
      handleUping() {
        this.loading = this.$loading({
          lock: true,
          text: "上传中,请等待...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.6)",
        });
      },
      handleFileUpSuccess(file) {
        // if (file.data.url && file.data.file_id) {
        //   this.fileList.push(file.data)
        //   this.$message.success('上传成功')
        //   this.loading.close();
        // }
        const url = `${this.uploadUrl}/${this.needParam.key}`;
        // 获取时长
        const audio = new Audio(url);
        const that = this;
        audio.addEventListener("loadedmetadata", () => {
          uploadComplete({
            file_type: "voice",
            size: that.uploadSize,
            duration: audio.duration,
            url: url,
          })
            .then((res) => {
              if (res.data.url && res.data.file_id) {
                this.file_id = res.data.file_id;
                this.fileList.push(res.data);
                this.$message.success("上传成功");
                this.loading.close();
                this.getMyVoiceList();
              }
            })
            .catch(() => {
              this.loading.close();
              this.fileList = [];
              // 重置上传组件
              this.$refs.upload.clearFiles();
            });
        });
        audio.load();
      },
      handleFileUpError() {
        this.$message.error("上传失败，请重新上传");
        this.loading.close();
      },
      getgvoiceChannel() {
        gvoiceChannel().then((res) => {
          this.voiceChannelList = [];
          this.voiceChannelList = res.data;
        });
      },
      // 根据api得出提示语
      getOneTip(val) {
        for (var i = 0; i < this.voiceChannelList.length; i++) {
          if (val == this.voiceChannelList[i].api) {

            this.upTip = this.voiceChannelList[i].upload_tips
            this.voice_channel_name = this.voiceChannelList[i].version_name
              ? this.voiceChannelList[i].upload_tips
              : "建议3-5分钟";
            break;
          }
        }
      },


      // 获取通道的名字
      getName(api) {
        if (this.voiceChannelList.length > 0) {
          for (let i = 0; i < this.voiceChannelList.length; i++) {
            if (this.voiceChannelList[i].api == api) {
              return this.voiceChannelList[i].name
              break
            }
          }
        }
      },


      getDigitColor(index) {
        const colors = ["#1890ff", "#52c41a", "#FFB700"];
        return index < 3
          ? colors[index]
          : colors[Math.floor(Math.random() * colors.length)];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .dialog-box {
    margin-top: -30px;

    h3 {
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
    }

    ul {
      padding-left: 0;
      margin: 0 0 16px 0;
      list-style: none;

      li {
        position: relative;
        padding-left: 18px; /* 给圆圈留空间 */
        margin-bottom: 18px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        line-height: 18px;
      }

      li::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px; /* 垂直居中微调 */
        width: 6px;
        height: 6px;
        border: 2px solid #f7d274; /* 圆圈颜色 */
        border-radius: 50%;
        background: transparent; /* 空心 */
        box-sizing: border-box;
      }
    }

    .clone-section {
      .guifan {
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        line-height: 18px;
      }
    }
  }

  .none-bar {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    // margin: 0 auto;

    .none-top {
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        margin-top: -70px;
        margin: -300 auto;
        font-weight: 500;
        font-size: 14px;
        color: #191919;
        line-height: 22px;
        text-align: center;
        line-height: 40px;
        width: 172px;
        height: 40px;
        background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
        border-radius: 8px;
      }

      img {
        // width: 694.3px;
        height: 236.46px;
      }
    }

    img {
      // margin-top: 134px;
      // width: 80%;
      height: 345px;
    }
  }

  .clone-box::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }

  .clone-box {
    box-shadow: 0 4px 12px 4px #0000000d;
    box-sizing: border-box;
    width: 100%;
    padding: 24px;
    height: calc(100vh - 50px);
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* Internet Explorer 10+ */

    p {
      margin: 0;
      padding: 0;
    }

    .clone-box-title {
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      line-height: 22px;
    }
  }

  .head-box {
    .choose-box {
      cursor: pointer;
      font-size: 18px;
      color: #7d87a1;
      line-height: 26px;
      font-weight: 500;
      height: 36px;
      margin-right: 30px;
    }

    .active {
      border-bottom: 2px solid #091221;
      color: #151b26;
    }
  }

  .dz-btn-box {
    width: 144px;
    height: 40px;
    background: #6c14ff;
    border-radius: 6px;

    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    margin-left: 15px;
  }

  .no-fenshen-box {
    margin-top: 40vh;

    img {
      width: 48px;
      height: 48px;
    }

    p {
      margin: 24px auto 28px;
    }

    font-weight: 400;
    font-size: 16px;
    color: #fafafa;
    text-align: center;

    .ks-dingzhi {
      width: 156px;
      height: 48px;
      background: linear-gradient(312deg, #6c14ff 0%, #01fbf5 100%);
      border-radius: 6px;

      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      line-height: 48px;
      text-align: center;
      margin: 0 auto;
    }
  }

  .my-voice {
    margin-top: 24px;

    .pp1 {
      font-size: 16px;
      line-height: 1;
      color: #091221;
      font-weight: 500;
      margin-bottom: 24px;

      span {
        font-size: 12px;
        margin-left: 8px;
        color: #888;
        letter-spacing: 1px;
      }
    }

    .clone-voice {
      margin-bottom: 25px;
      width: 392px;
      display: flex;
      padding: 8px;
      background: #1a1a1a;
      /*border: 1px #e2e6ff dashed;*/
      border-radius: 6px;
      border: 1px solid rgba(247, 210, 116, 0.2);
      gap: 12px;
      height: 82px;

      img {
        margin-top: 10px;
        width: 40px;
        height: 44px;
      }

      .part1 {
        width: 280px;
        padding-top: 10px;

        p:first-child {
          font-weight: 500;
          font-size: 15px;
          color: #ffffff;
          font-weight: 500;
          margin-bottom: 5px;
        }

        p:last-child {
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.6);
        }
      }

      .part2 {
        // width: 30px;

        .part2-text {
          width: 114px;
          height: 32px;
          background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
          background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%);
          border-radius: 16px;
          font-weight: 500;
          font-size: 14px;
          color: #191919;
          text-align: center;
          line-height: 32px;
          margin-top: 20px;
        }
      }
    }

    .every-voice {
      margin-right: 25px;
      margin-bottom: 25px;
      cursor: pointer;
      position: relative;
      width: 392px;
      display: flex;
      padding: 8px;
      background: #1a1a1a;
      border-radius: 8px;
      border: 1px solid rgba(247, 210, 116, 0.2);
      gap: 12px;
      height: 82px;

      .type1-tips-new {
        // position: absolute;
        // right: 0;
        left: 0;
        bottom: 0;
        min-width: 52px;
        height: 20px;
        background: #2550f6;
        border-radius: 4px;
        padding: 0 8px;

        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }

      .type1-tips,
      .type2-tips {
        position: absolute;
        right: 0;
        bottom: 0;
        min-width: 52px;
        height: 20px;
        background: #2550f6;
        border-radius: 4px;

        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
      }

      .type2-tips {
        background: #7bbf00;
      }

      .card-img {
        position: relative;
        width: 44px;
        height: 44px;
        border-radius: 50%;
        margin-right: 16px;

        img {
          width: 100%;
          height: 100%;
          object-fit: fill;
          border-radius: 50%;
          /*border-radius: 8px;*/
        }

        .hover-box {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          border-radius: 50%;
          text-align: center;
          background: rgba(0, 0, 0, 0.5);
          cursor: pointer;
          justify-content: center;
          align-items: center;

          .play-pause-btn {
            margin-top: 10px;

            .playing-box {
              width: 30px;
              height: 18px;
            }
          }
        }
      }

      .pp4 {
        font-size: 14px;
        color: #fff;
        line-height: 24px;
        font-weight: 500;
        margin-bottom: 5px;
      }

      .pp5 {
        font-size: 12px;
        font-weight: 400;
        color: #aaaab5;
      }

      .all-tags {
        .every-tag {
          font-size: 12px;
          color: #5b647a;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          font-weight: 400;
          background: #edeef7;
          border-radius: 4px;
          padding: 0 4px;
          white-space: nowrap;
          margin-right: 5px;
        }
      }

      .handle-box {
        position: absolute;
        top: 3px;
        right: 10px;

        .edit-btn {
          margin-right: 10px;
          margin-top: 26px;
          font-weight: 400;
          font-size: 14px;
          color: #e9dec2;
        }
      }
    }
  }

  .handle-box-pop {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    .text-btn {
      color: rgba(255, 255, 255, 0.8);
      font-weight: 400;
      font-size: 14px;
    }
  }

  .upload-box {
    img {
      width: 58px;
      height: 58px;
    }

    .video-one {
      margin-bottom: 8px;
      font-weight: 500;
      font-size: 15px;
      color: #ffffff;
    }
  }

  .submit-btn {
    margin: 30px 0;
    background: linear-gradient(135deg, #f7d274 0%, #f5dfb5 100%) !important;
    width: 100%;
    display: inline-block;
    vertical-align: middle;
    height: 38px;
    line-height: 38px;
    border: 1px solid transparent;
    padding: 0 18px;
    font-weight: 400;
    font-size: 14px;
    color: #191919;
    white-space: nowrap;
    text-align: center;
    border-radius: 2px;
    cursor: pointer;
  }

  .pp3 {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    font-weight: 500;
    margin: 15px 0 !important;
  }

  .voice-yq {
    // padding: 16px;
    border-radius: 6px;

    .ul-box {
      // line-height: 25px;
      display: grid;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }

    ul {
      padding-left: 0;
      // margin: 0 0 0 0;
      list-style: none;

      li {
        position: relative;
        padding-left: 18px; /* 给圆圈留空间 */
        // margin-bottom: 8px;
        font-weight: 400;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
      }

      li::before {
        content: "";
        position: absolute;
        left: 0;
        top: 8px; /* 垂直居中微调 */
        width: 6px;
        height: 6px;
        border: 2px solid #f7d274; /* 圆圈颜色 */
        border-radius: 50%;
        background: transparent; /* 空心 */
        box-sizing: border-box;
      }
    }
  }
</style>
<style lang="scss">
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #f7d274;
  }

  .shengyinkelong .el-dialog__header {
    border-bottom: 1px solid #9797974d;
  }

  .el-input__inner {
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
  }

  .el-input-group__append {
    background-color: #1a1a1a;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-left: none;
  }

  .clone-box .el-dialog__body {
    padding: 0 30px !important;
  }

  .upload-box .el-upload {
    width: 100%;
  }

  .upload-box .el-upload .el-upload-dragger {
    border: 1px dashed #f7d274;

    width: 100% !important;
    background: #1f1f1f !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .custom-dialog {
    width: 780px !important;
    padding: 0 !important;
    border-radius: 20px;

    .header-img {
      position: relative;

      .img1 {
        width: 100%;
        height: 110px;
      }

      .img2 {
        position: absolute;
        width: 32px;
        height: 32px;
        top: 0;
        right: 0;
        z-index: 9;
      }
    }

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0 !important;
    }
  }

  .ai-choose-box {
    // padding: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .ai-part2-box {
      width: 292px;
      height: 192px;
      background: #1f1f1f;
      border-radius: 8px;
      // border: 1px solid #eeeeee;
      margin-right: 20px;
      position: relative;
    }

    .ai-part2-box:last-child {
      margin-right: 0;
    }

    .aipp1 {
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      width: 190px;
      margin: 0 auto 8px;

      img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }
    }

    .aipp2 {
      // width: 190px;
      height: 60px;
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
      line-height: 20px;
      text-align: center;
      margin: 0 auto;
    }

    .aipp21 {
      font-weight: 400;
      font-size: 10px;
      color: rgba(255, 255, 255, 0.7);
      text-align: center;
      margin-top: -30px;
      margin-bottom: 20px;
      // margin: 0 auto;
    }

    .aipp4 {
      font-weight: 500;
      font-size: 18px;
      color: #237aff;
      line-height: 25px;
      text-align: center;
      margin-top: 24px;

      .jf-text {
        font-weight: 400;
        font-size: 12px;
        color: #222222;
      }
    }

    .aibtn2 {
      width: 244px;
      height: 40px;
      background: #237aff;
      border-radius: 4px;

      font-weight: 500;
      font-size: 14px;
      color: #191919;
      line-height: 36px;
      text-align: center;
      margin: 0 auto;
    }

    .aipp5 {
      position: absolute;
      right: 10%;
      top: 10%;
      padding: 0 8px;
      height: 22px;
      background: #ffb700;
      // border-radius: 6px;
      line-height: 22px;
      border-radius: 10px 10px 10px 0px;
      font-weight: 500;
      font-size: 12px;
      font-weight: 500;
      font-size: 11px;
      color: #ffffff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/clone.vue